import { STATUS_TONE, type StatusTone } from '@skylabs-digital/backoffice-kit';

/**
 * backoffice-kit 2 tipa `STATUS_TONE` como objeto cerrado (`as const`), asi
 * que indexarlo con un `string` cualquiera ya no compila. noten tiene estados
 * propios que el kit no conoce (`RETRY_SCHEDULED`, `OPTED_OUT`, ...): esta
 * funcion es el unico lugar donde se resuelve el tono y el fallback.
 */
/**
 * The kit's default `STATUS_TONE` maps `SENT -> success` (a generic
 * CRUD/messaging heuristic). In noten `SENT` means only "accepted by the
 * provider" (RFC 0002 §2 Fase 3) — `DELIVERED`, confirmed by webhook, is the
 * only real success. Override it locally rather than asking the kit to carry
 * noten-specific semantics.
 */
const NOTEN_STATUS_TONE_OVERRIDES: Readonly<Record<string, StatusTone>> = {
  SENT: 'info',
};

const TONES: Readonly<Record<string, StatusTone>> = {
  ...STATUS_TONE,
  ...NOTEN_STATUS_TONE_OVERRIDES,
};

export function statusTone(status: string, fallback: StatusTone = 'neutral'): StatusTone {
  return TONES[status] ?? fallback;
}
